module.exports = __webpack_public_path__ + "73fe5aafae0371c75e4e4fb4ecffd4e7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-6.png
// module id = 1769
// module chunks = 0